import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { SupportTypeCellRenderer } from "../column-def-cell-renderers/SupportTypeCellRenderer";
import { regionColumnDef } from "../common/regionColumnDef";
import { FilteredSqlResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const gkeColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Cluster Name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("gke"),

  {
    field: "resource.support_type",
    headerName: "Support Type",
    cellRenderer: ({ data }: ICellRendererParams<FilteredSqlResourceItem>) => {
      return (
        <SupportTypeCellRenderer supportType={data?.resource?.support_type} />
      );
    },
  },

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  {
    field: "resource.node_pool_count",
    headerName: "Node Pools Count",
  },
  {
    field: "resource.nodes_count",
    headerName: "Nodes Count",
  },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
